(function () {
  'use strict';

  angular.module('app').component('searchByItem', searchByItem());

  function searchByItem() {
    return {
      bindings: {
        item: '=',
        searchedProduct: '=',
        onSave: '&',
        onClear: '&',
      },
      templateUrl: './app/ajs/bookings/search-by-item/search-by-item.component.html',
      controller: SearchByItemCtrl,
      controllerAs: 'vm',
    };
  }

  SearchByItemCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TourService',
    'TransportationService',
  ];

  function SearchByItemCtrl(config, UtilService, TourService, TransportationService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);
    vm.dateDisplay = config.DATE_DISPLAY; // month day, year
    vm.hourDisplay = config.HOUR_DISPLAY; // hh:mm a
    vm.sendingForm = false;

    vm.itemTypes = [
      { icon: 'suitcase', title: 'ITINERARIES', option: 'itineraries' },
      { icon: 'binoculars', title: 'TOURS', option: 'tours' },
      { icon: 'truck', title: 'TRANSPORTATIONS', option: 'transportations' },
      // {icon: 'building', title: 'HOTELS', option: 'hotels'}
    ];

    vm.$onInit = function () {
      getTours();
      getTransportations();
      // getHotels();
    };

    vm.selectItemType = selectItemType;
    vm.selectItem = selectItem;
    vm.selectTourOption = selectTourOption;
    vm.canShowItemDepartures = canShowItemDepartures;
    vm.canShowItemOptions = canShowItemOptions;
    vm.save = save;
    vm.clear = clear;

    // get tours list
    function getTours() {
      TourService.getTours({ get: 'selector' }).then(function () {
        vm.tours = TourService.items;
        if (vm.item.itemType && vm.item.itemType.option === 'tours') {
          vm.items = vm.tours;

          if (vm.item.itemSelected) {
            vm.tourOptions = vm.item.itemSelected.tour_options;
          }

          if (vm.item.tourOption) {
            vm.departures = vm.item.tourOption.tour_option_schedules;
          }
        }
      });
    }

    // get transportations list
    function getTransportations() {
      TransportationService.getTransportations({ get: 'selector' }).then(function () {
        vm.transportations = TransportationService.items;
        if (vm.item.itemType && vm.item.itemType.option === 'transportations') {
          vm.items = vm.transportations;

          if (vm.item.itemSelected) {
            vm.tourOptions = [];
          }

          if (vm.item.tourOption) {
            vm.departures = vm.item.itemSelected.transportation_schedules;
          }
        }
      });
    }

    // get hotels list
    function getHotels() {
      vm.hotels = [];
    }

    // select the item type and add the items to items selector
    function selectItemType() {
      switch (vm.item.itemType.option) {
        case 'tours':
          vm.items = vm.tours;
          break;
        case 'transportations':
          vm.items = vm.transportations;
          break;
        case 'hotels':
          vm.items = vm.hotels;
          break;
      }

      vm.tourOptions = [];
      vm.departures = [];
      vm.item.itemSelected = null;
      vm.item.tourOption = null;
      vm.item.departure = null;
    }

    // select the item and add the items to tour options selector
    function selectItem() {
      if (vm.item.itemType.option === 'tours') {
        vm.tourOptions = vm.item.itemSelected.tour_options;
        vm.departures = [];
      } else if (vm.item.itemType.option === 'transportations') {
        vm.departures = vm.item.itemSelected.transportation_schedules;
      }

      vm.item.tourOption = null;
      vm.item.departure = null;
    }

    // select the tour option and add the items to departures selector
    function selectTourOption() {
      vm.departures = vm.item.tourOption.tour_option_schedules;
      vm.item.departure = null;
    }

    function canShowItemOptions() {
      var response = false;
      if (vm.item.itemType) {
        switch (vm.item.itemType.option) {
          case 'itineraries':
            response = false;
            break;
          case 'tours':
            if (vm.item.itemType && vm.item.itemSelected && vm.item.itemType.option === 'tours') {
              response = true;
            }
            break;
          case 'transportations':
            response = false;
            break;
          case 'hotels':
            response = false;
            break;
        }
      }

      return response;
    }

    function canShowItemDepartures() {
      var response = false;
      if (vm.item.itemType) {
        switch (vm.item.itemType.option) {
          case 'itineraries':
            response = false;
            break;
          case 'tours':
            if (
              vm.item.itemType &&
              vm.item.itemSelected &&
              vm.item.tourOption &&
              vm.item.itemType.option === 'tours'
            ) {
              response = true;
            }
            break;
          case 'transportations':
            response = true;
            break;
          case 'hotels':
            response = false;
            break;
        }
      }
      return response;
    }

    // save action
    function save(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
      } else {
        vm.searchedProduct = true;
        vm.onSave();
      }
    }

    function clear() {
      vm.onClear();
    }
  }
})();
